import { TableRow, TableCell, Box, Typography, IconButton } from '@mui/material';
import { ArrowDropDown as DropDownIcon, ArrowDropUp as DropDownUpIcon } from '@mui/icons-material';
import { AdminUser, AdminPermission } from '@localstack/types';
import { hashEmail } from '@localstack/services';

import { StyledAvatar, YouChip, SuperAdminChip, DropdownTableCell, NoHoverTableRow } from './AdminUsers';

export const AdminUserRow = ({
  adminUser,
  isActive,
  isSelf,
  onToggle,
  activeRowRef,
  children,
}: {
  adminUser: AdminUser;
  isActive: boolean;
  isSelf: boolean;
  onToggle: () => void;
  activeRowRef: React.RefObject<HTMLTableRowElement>;
  children?: React.ReactNode;
}): JSX.Element => {
  return (
    <>
      <TableRow onClick={onToggle} ref={isActive ? activeRowRef : null}>
        <TableCell>
          <Box display="flex" flexWrap="nowrap" alignItems="center">
            <StyledAvatar
              alt={adminUser.email || ''}
              src={`https://www.gravatar.com/avatar/${hashEmail(adminUser.email)}?d=db`}
            />
            <Box display="flex" flexDirection="column">
              <Box display="flex">
                <Typography variant="body1">
                  <b>{adminUser.email}</b>
                </Typography>
                {isSelf && <YouChip>You</YouChip>}
                {adminUser.permissions.includes(AdminPermission.SUPER_ADMIN) && (
                  <SuperAdminChip>Super Admin</SuperAdminChip>
                )}
              </Box>
            </Box>
          </Box>
        </TableCell>
        <DropdownTableCell>
          <IconButton onClick={onToggle} size="large">
            {isActive ? <DropDownUpIcon /> : <DropDownIcon />}
          </IconButton>
        </DropdownTableCell>
      </TableRow>
      {isActive && (
        <NoHoverTableRow>
          <TableCell colSpan={4}>{children}</TableCell>
        </NoHoverTableRow>
      )}
    </>
  );
};
